module.exports = __webpack_public_path__ + "static/media/anonymous.8861ce9a.svg";